import { PRODUCT_REVIEW_FIELDS } from '@@partner:graphql/shortcuts'
import type { ProductReviewInfo } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface ProductReviewInput {
  id?: GQL_ID
  product_id?: GQL_ID
  comment?: string
  status: number
}

export interface UpdateProductReview {
  productReview: ProductReviewInfo
}

export interface SaveProductReviewVariables {
  newData: ProductReviewInput
  upsert?: boolean
}

export const GQL_MUTATION_SAVE_PRODUCT_REVIEW = gql`
  mutation($newData: ProductReviewInput!, $upsert: Boolean!) {
    productReviewInfo: updateProductReview(newData: $newData, upsert: $upsert) {
      ${PRODUCT_REVIEW_FIELDS}
    }
  }
`

export const useUpdateProductReview = () => {
  return useMutation<UpdateProductReview, SaveProductReviewVariables>(
    GQL_MUTATION_SAVE_PRODUCT_REVIEW
  )
}
